
const featureToggleSubscription = require('./subscriptionV2.js')
const featureToggleCloverleaf = require('./cloverleaf.js')

const isFeatureActive = environmentVariable => environmentVariable === 'true'

const toggles = (rawToggles = {}) => {
  return {
    useNewPdfService: () => isFeatureActive(rawToggles.FEATURE_USE_NEW_PDF_SERVICE),
    useNewSubscriptionServiceForCountryCode: code => featureToggleSubscription(rawToggles.FEATURE_SUBSCRIPTION_V2_COUNTRIES, code),
    useInternalExpenses: () => isFeatureActive(rawToggles.FEATURE_USE_INTERNAL_EXPENSES),
    useStream: () => isFeatureActive(rawToggles.FEATURE_USE_STREAM),
    useAuthUserSync: () => isFeatureActive(rawToggles.FEATURE_AUTH_SYNC_USER),
    useCloverleafForCollection: collection => featureToggleCloverleaf(rawToggles.FEATURE_CLOVERLEAF_COLLECTIONS, collection),

    // If your new feature uses the connector-service then add the toggle env to the array below
    useConnectorService: () => [
      rawToggles.FEATURE_SUBSCRIPTION_V2_COUNTRIES,
      rawToggles.FEATURE_USE_NEW_PDF_SERVICE,
      rawToggles.FEATURE_USE_INTERNAL_EXPENSES
    ]
    // Check for 'false' just in case...
      .some(v => !!v && v !== 'false')
  }
}

module.exports = toggles
